
import { Input } from "@/components/ui/input";
import { Calendar } from "@/components/ui/calendar";
import { useTheme } from "@/lib/theme/ThemeContext";

interface AddChildFormProps {
  name: string;
  setName: (name: string) => void;
  dateOfBirth: Date | undefined;
  setDateOfBirth: (date: Date | undefined) => void;
}

export function AddChildForm({ name, setName, dateOfBirth, setDateOfBirth }: AddChildFormProps) {
  const isLightTheme = false;

  return (
    <div className="space-y-4 py-4">
      <div className="space-y-2">
        <label className={`text-sm font-medium ${
          isLightTheme ? "text-slate-700" : "text-gray-200"
        }`}>
          Child's Name
        </label>
        <Input
          placeholder="Enter name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={
            isLightTheme 
              ? "bg-white border-slate-200 focus:border-blue-primary focus:ring-blue-primary/20" 
              : "bg-[#2D3B4E] border-gray-600 text-gray-100"
          }
        />
      </div>

      <div className="space-y-2">
        <label className={`text-sm font-medium ${
          isLightTheme ? "text-slate-700" : "text-gray-200"
        }`}>
          Date of Birth
        </label>
        <Calendar
          mode="single"
          selected={dateOfBirth}
          onSelect={setDateOfBirth}
          disabled={(date) => date > new Date()}
          className={`rounded-md border ${
            isLightTheme 
              ? "border-slate-200 bg-white" 
              : "border-gray-600 bg-[#2D3B4E]"
          }`}
          classNames={{
            day: `h-9 w-9 p-0 font-normal ${
              isLightTheme 
                ? "text-slate-700 hover:bg-blue-50 focus:bg-blue-50" 
                : "text-gray-100 hover:bg-gray-700 focus:bg-gray-700"
            }`,
            day_selected: `${
              isLightTheme 
                ? "bg-blue-primary text-white hover:bg-blue-600 hover:text-white focus:bg-blue-600 focus:text-white" 
                : "bg-[#9B87F5] text-white hover:bg-[#8A74F4] hover:text-white focus:bg-[#8A74F4] focus:text-white"
            }`,
            day_today: `${
              isLightTheme ? "bg-blue-50 text-blue-600" : "bg-gray-700 text-white"
            }`,
            day_outside: `${
              isLightTheme ? "text-slate-300" : "text-gray-500"
            }`
          }}
        />
      </div>
    </div>
  );
}
